export default "__VITE_ASSET__TvhizMaD__"